import * as React from "react";
import { SVGProps } from "react";

const SvgFourDiamonds = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 285 398"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M273.5 0H11.7S.7.3.7 14.8v367.6c0 14.5 11 14.8 11 14.8h261.9s11-.3 11-14.8V14.8C284.5.3 273.5 0 273.5 0Z"
      fill="#fff"
    />
    <mask
      id="four-diamonds_svg__b"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={214}
      width={285}
      height={184}
    >
      <path
        d="M168.1 214.4c-55.8 0-111.6 0-167.3.1v168c0 14.5 11 14.8 11 14.8h261.8s11-.3 11-14.8V214.4H168.1Z"
        fill="url(#four-diamonds_svg__a)"
      />
    </mask>
    <g mask="url(#four-diamonds_svg__b)">
      <path
        d="M168.1 214.4c-55.8 0-111.6 0-167.3.1v168c0 14.5 11 14.8 11 14.8h261.8s11-.3 11-14.8V214.4H168.1Z"
        fill="url(#four-diamonds_svg__c)"
      />
    </g>
    <mask
      id="four-diamonds_svg__e"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={285}
      height={199}
    >
      <path
        d="M.7 198.2c23.9 0 47.8 0 71.7.1 68.8 0 137.7 0 206.5.1h5.7V14.8c0-14.5-11-14.8-11-14.8H11.7S.7.3.7 14.8V198.2Z"
        fill="url(#four-diamonds_svg__d)"
      />
    </mask>
    <g mask="url(#four-diamonds_svg__e)">
      <path
        d="M.7 198.2c23.9 0 47.8 0 71.7.1 68.8 0 137.7 0 206.5.1h5.7V14.8c0-14.5-11-14.8-11-14.8H11.7S.7.3.7 14.8V198.2Z"
        fill="url(#four-diamonds_svg__f)"
      />
    </g>
    <mask
      id="four-diamonds_svg__h"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={6}
      y={0}
      width={279}
      height={398}
    >
      <path
        d="M284 14.8V382c0 14.5-11 14.8-11 14.8H10.9s-2.4-.1-4.9-1.6c2.8 2.1 5.8 2.2 5.8 2.2h261.9s11-.3 11-14.8V14.8c0-14.5-11-14.8-11-14.8h-.6C273 0 284 .3 284 14.8Z"
        fill="url(#four-diamonds_svg__g)"
      />
    </mask>
    <g mask="url(#four-diamonds_svg__h)">
      <path
        d="M284 14.8V382c0 14.5-11 14.8-11 14.8H10.9s-2.4-.1-4.9-1.6c2.8 2.1 5.8 2.2 5.8 2.2h261.9s11-.3 11-14.8V14.8c0-14.5-11-14.8-11-14.8h-.6C273 0 284 .3 284 14.8Z"
        fill="url(#four-diamonds_svg__i)"
      />
    </g>
    <mask
      id="four-diamonds_svg__k"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={280}
      height={398}
    >
      <path
        d="M1.3 382.5V15.4C1.3.9 12.3.6 12.3.6h262.1s2.4.1 4.9 1.6C276.5.1 273.5 0 273.5 0H11.7S.7.3.7 14.8v367.6c0 14.5 11 14.8 11 14.8h.6c0 .1-11-.2-11-14.7Z"
        fill="url(#four-diamonds_svg__j)"
      />
    </mask>
    <g mask="url(#four-diamonds_svg__k)">
      <path
        d="M1.3 382.5V15.4C1.3.9 12.3.6 12.3.6h262.1s2.4.1 4.9 1.6C276.5.1 273.5 0 273.5 0H11.7S.7.3.7 14.8v367.6c0 14.5 11 14.8 11 14.8h.6c0 .1-11-.2-11-14.7Z"
        fill="url(#four-diamonds_svg__l)"
      />
      <mask
        id="four-diamonds_svg__n"
        style={{
          maskType: "alpha",
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={28}
        width={2}
        height={344}
      >
        <path
          d="M.7 28.7v342.6l.6-2.1V34.9c-.2-2-.4-4.1-.6-6.2Z"
          fill="url(#four-diamonds_svg__m)"
        />
      </mask>
      <g mask="url(#four-diamonds_svg__n)">
        <path
          d="M.7 28.7v342.6l.6-2.1V34.9c-.2-2-.4-4.1-.6-6.2Z"
          fill="url(#four-diamonds_svg__o)"
        />
      </g>
    </g>
    <path
      d="M34.7 74.3c-7.2-4-12.9-16.1-13.1-16.4-.2.4-5.9 12.5-13.1 16.4 7.2 4 12.9 16.1 13.1 16.4.2-.3 5.9-12.4 13.1-16.4ZM20.3 50.2c1-.3 1.7-.6 2.1-.9.4-.3.6-.8.7-1.4.1-.6.2-1.5.2-2.8V41H9.4v-1.9L24 17h3.6v21.6h.5c1 0 1.7-.1 2.1-.2.4-.1.8-.4 1-.8.3-.4.5-.9.8-1.8h1.9l-.3 5.2h-6v4.1c0 1.1 0 1.9.1 2.5.1.5.2.9.4 1.2.2.3.4.6.8.8.3.2.9.4 1.7.6v1.2H20.4v-1.2h-.1Zm-6.9-11.6h9.8v-6.2c0-1.6 0-3.3.1-5.3.1-1.9.1-3.4.2-4.4h-.3l-9.8 15.6v.3ZM248.4 322.2c7.2 4 12.9 16.1 13.1 16.4.2-.4 5.9-12.5 13.1-16.4-7.2-4-12.9-16.1-13.1-16.4-.1.3-5.9 12.4-13.1 16.4ZM262.8 346.3c-1 .3-1.7.6-2.1.9-.4.3-.6.8-.7 1.4-.1.6-.2 1.5-.2 2.8v4.1h13.9v1.9L259 379.6h-3.6V358h-.5c-1 0-1.7.1-2.1.2-.4.1-.8.4-1 .8-.3.4-.5 1-.8 1.8h-1.9l.3-5.2h6v-4.1c0-1.1 0-1.9-.1-2.5-.1-.5-.2-.9-.4-1.2-.2-.3-.4-.6-.8-.8-.3-.2-.9-.4-1.7-.6V345h10.2v1.3h.2Zm6.9 11.6h-9.8v6.2c0 1.6 0 3.3-.1 5.3 0 1.9-.1 3.4-.2 4.4h.3l9.8-15.6v-.3ZM116.1 317.8c-14.3-7.9-25.7-31.9-26-32.6-.4.8-11.8 24.7-26 32.6 14.3 7.9 25.7 31.9 26 32.6.3-.7 11.7-24.7 26-32.6ZM116.1 79.5c-14.3-7.9-25.7-31.9-26-32.6-.4.8-11.8 24.7-26 32.6 14.3 7.9 25.7 31.9 26 32.6.3-.7 11.7-24.7 26-32.6ZM220.9 317.8c-14.3-7.9-25.7-31.9-26-32.6-.4.8-11.8 24.7-26 32.6 14.3 7.9 25.7 31.9 26 32.6.4-.7 11.8-24.7 26-32.6ZM220.9 79.5c-14.3-7.9-25.7-31.9-26-32.6-.4.8-11.8 24.7-26 32.6 14.3 7.9 25.7 31.9 26 32.6.4-.7 11.8-24.7 26-32.6Z"
      fill="#FF2601"
    />
    <defs>
      <radialGradient
        id="four-diamonds_svg__a"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(138.233 -135.451) scale(574.543)"
      >
        <stop offset={0.616} />
        <stop offset={0.752} stopColor="#020202" />
        <stop offset={0.804} stopColor="#090909" />
        <stop offset={0.841} stopColor="#151515" />
        <stop offset={0.872} stopColor="#262626" />
        <stop offset={0.899} stopColor="#3C3C3C" />
        <stop offset={0.922} stopColor="#585858" />
        <stop offset={0.944} stopColor="#797979" />
        <stop offset={0.963} stopColor="#9F9F9F" />
        <stop offset={0.982} stopColor="#CBCBCB" />
        <stop offset={0.998} stopColor="#F9F9F9" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="four-diamonds_svg__c"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(138.233 -135.451) scale(574.543)"
      >
        <stop offset={0.616} stopColor="#fff" />
        <stop offset={0.788} stopColor="#FDFDFD" />
        <stop offset={0.854} stopColor="#F6F6F6" />
        <stop offset={0.901} stopColor="#EAEAEA" />
        <stop offset={0.94} stopColor="#D9D9D9" />
        <stop offset={0.974} stopColor="#C3C3C3" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
      <radialGradient
        id="four-diamonds_svg__d"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(143.916 366.656) scale(411.699)"
      >
        <stop offset={0.616} />
        <stop offset={0.71} stopColor="#020202" />
        <stop offset={0.762} stopColor="#0A0A0A" />
        <stop offset={0.805} stopColor="#181818" />
        <stop offset={0.842} stopColor="#2C2C2C" />
        <stop offset={0.875} stopColor="#464646" />
        <stop offset={0.906} stopColor="#656565" />
        <stop offset={0.935} stopColor="#8A8A8A" />
        <stop offset={0.963} stopColor="#B6B6B6" />
        <stop offset={0.988} stopColor="#E5E5E5" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="four-diamonds_svg__f"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(143.916 366.656) scale(411.699)"
      >
        <stop offset={0.616} stopColor="#fff" />
        <stop offset={0.747} stopColor="#FDFDFD" />
        <stop offset={0.821} stopColor="#F5F5F5" />
        <stop offset={0.88} stopColor="#E7E7E7" />
        <stop offset={0.932} stopColor="#D3D3D3" />
        <stop offset={0.978} stopColor="#BABABA" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
      <radialGradient
        id="four-diamonds_svg__g"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-11.419 -.179) scale(457.13)"
      >
        <stop offset={0.099} />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="four-diamonds_svg__i"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-11.419 -.179) scale(457.13)"
      >
        <stop offset={0.099} stopColor="#fff" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
      <radialGradient
        id="four-diamonds_svg__j"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(78.242 115.635) scale(389.352)"
      >
        <stop />
        <stop offset={0.007} stopColor="#090909" />
        <stop offset={0.048} stopColor="#373737" />
        <stop offset={0.093} stopColor="#626262" />
        <stop offset={0.142} stopColor="#888" />
        <stop offset={0.195} stopColor="#A8A8A8" />
        <stop offset={0.254} stopColor="#C4C4C4" />
        <stop offset={0.32} stopColor="#DADADA" />
        <stop offset={0.397} stopColor="#EBEBEB" />
        <stop offset={0.493} stopColor="#F6F6F6" />
        <stop offset={0.627} stopColor="#FDFDFD" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="four-diamonds_svg__l"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(78.242 115.635) scale(389.352)"
      >
        <stop stopColor="#fff" />
        <stop offset={0.141} stopColor="#fff" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="four-diamonds_svg__m"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(-456.906 0 0 -456.924 296.299 -.18)"
      >
        <stop offset={0.099} />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="four-diamonds_svg__o"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(-456.906 0 0 -456.924 296.299 -.18)"
      >
        <stop offset={0.099} stopColor="#fff" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
    </defs>
  </svg>
);

export default SvgFourDiamonds;
